export default "__VITE_ASSET__CWKTqxjv__"